
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Etioscabforoutstationinpune() {



    const cardData =
    {
        keyword: ' Etios Cab for Outstation in Pune',
        heading: 'Prince Cabs: Etios Cab for Outstation in Pune',
        headingDescription: 'Prince Cabs offers reliable Etios Cab for Outstation in Pune, perfect for family tours, business trips, pilgrimages, and weekend getaways. Our well-maintained Toyota Etios sedans provide a safe, spacious, and fuel-efficient travel experience, making long-distance journeys comfortable and affordable. With professional chauffeurs, flexible travel plans, and on-time pickups, we ensure a smooth and hassle-free ride to popular destinations like Shirdi, Nashik, Mahabaleshwar, and Mumbai. Travel with confidence and convenience through Prince Cabs’ trusted Etios outstation cab service in Pune.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

  "topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located about 120 km from Pune, Mahabaleshwar is a famous hill station in the Sahyadri ranges. Known for its strawberry farms, Venna Lake, and viewpoints like Arthur’s Seat, it offers breathtaking valley views. The Mahabaleshwar Temple adds spiritual significance. Monsoon brings lush greenery and waterfalls, while winter creates a cozy retreat. Horse riding, boating, and fresh local delicacies enhance the experience. It is Pune’s most popular weekend getaway."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are twin hill stations famous for their scenic landscapes and forts. Attractions include Bhushi Dam, Karla and Bhaja Caves, Tiger’s Leap, and Rajmachi Fort. Monsoon transforms the valleys into a carpet of green dotted with waterfalls. Adventure lovers enjoy trekking and camping near Pawna Lake. Chikki, the local sweet, is a must-try. These hill stations remain Pune’s most loved short-trip destinations."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, a planned city inspired by Italian architecture, is located 60 km from Pune. Built around a scenic lake, it is popular for its colorful promenade, cycling, and lakeside dining. Visitors enjoy boating, adventure sports, and wellness retreats. The modern cityscape looks especially stunning during monsoon. It is a favorite among families, couples, and corporate groups. Lavasa combines natural beauty with a cosmopolitan vibe."
  },
  {
    "title": "Panchgani",
    "description": "Situated 100 km from Pune, Panchgani is a serene hill station surrounded by five hills. Its main attraction is Table Land, Asia’s second-largest volcanic plateau. Strawberry farms, colonial-era boarding schools, and viewpoints add charm. Paragliding and trekking attract adventure seekers. The weather remains pleasant throughout the year. Panchgani is often combined with Mahabaleshwar for a complete hill retreat."
  },
  {
    "title": "Matheran",
    "description": "About 120 km from Pune, Matheran is Asia’s only automobile-free hill station. It is known for its red soil pathways, toy train ride, and 30+ viewpoints including Panorama Point and Echo Point. Trekking through forests is a highlight, especially in monsoon. The peaceful environment makes it unique among hill stations. Families and couples love its eco-friendly charm. It offers a refreshing break from city life."
  },
  {
    "title": "Alibaug",
    "description": "Located about 140 km from Pune, Alibaug is a coastal town known for its beaches and sea forts. Popular spots include Alibaug Beach, Kolaba Fort, and Varsoli Beach. Nagaon Beach is famous for water sports like jet skiing and parasailing. The town is also known for seafood and homestays. Sunsets over the Arabian Sea are stunning. Alibaug offers the perfect mix of history and seaside relaxation."
  },
  {
    "title": "Tarkarli",
    "description": "Tarkarli, located about 385 km from Pune, is Maharashtra’s scuba diving capital. Its crystal-clear waters, white sandy beaches, and vibrant coral reefs attract water sports lovers. Visitors enjoy snorkeling, parasailing, and dolphin-spotting boat rides. Sindhudurg Fort nearby adds a historical touch. Homestays and resorts offer authentic Konkani hospitality. Tarkarli is a paradise for beach lovers and adventure seekers."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, about 185 km from Pune, is one of India’s most visited pilgrimage towns. It is home to the Samadhi Mandir of Shri Sai Baba, Dwarkamai, Chavadi, and Gurusthan. Thousands of devotees gather daily for darshan and aartis. The town has excellent facilities for pilgrims including hotels and food courts. Many combine their visit with nearby Shani Shingnapur. Shirdi is a soulful retreat filled with faith and devotion."
  },
  {
    "title": "Nashik",
    "description": "Located about 210 km from Pune, Nashik is famous for its temples, vineyards, and ghats. The Trimbakeshwar Temple, one of the 12 Jyotirlingas, attracts thousands of devotees. Panchavati and Sita Gufa add mythological significance. Nashik is also known as India’s wine capital with Sula Vineyards and others offering tours and tastings. The city hosts the Kumbh Mela every 12 years. It is a blend of spirituality and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, 230 km from Pune, is a cultural and religious hub famous for the Mahalaxmi Temple, a Shakti Peetha. Visitors also explore Rankala Lake, New Palace Museum, and Panhala Fort. The city is renowned for its spicy Kolhapuri cuisine and handcrafted chappals. Festivals like Navratri are celebrated with grandeur. Kolhapur offers a mix of devotion, history, and local flavors. It is a rewarding weekend getaway."
  },
  {
    "title": "Satara (Kaas Plateau)",
    "description": "Satara, about 110 km from Pune, is best known for the Kaas Plateau, a UNESCO World Heritage Site. During monsoon, the plateau blooms with rare and colorful flowers, earning it the title ‘Valley of Flowers of Maharashtra.’ Sajjangad Fort and Thoseghar Waterfalls add to its attractions. Photographers and trekkers find it captivating. The region is especially vibrant between August and October. Satara is a monsoon paradise for nature lovers."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description": "Around 250 km from Pune near Aurangabad, the Ajanta and Ellora Caves are UNESCO World Heritage Sites. Ajanta features Buddhist frescoes and sculptures dating to the 2nd century BC, while Ellora includes Hindu, Buddhist, and Jain temples. The Kailasa Temple at Ellora is a monolithic marvel. These caves represent India’s ancient art, history, and spirituality. They are a must-visit for heritage and culture enthusiasts."
  }
],

"services": [
    {
        "name": "Etios Taxi Rate per km",
        "description": "Get transparent and affordable Etios taxi rates per kilometer for local and outstation trips. Our pricing ensures you get the best value for comfortable and reliable travel across Pune and beyond."
    },
    {
        "name": "Etios Taxi Booking Online",
        "description": "Easily book your Toyota Etios taxi online with quick and hassle-free reservation options. Secure your ride instantly for local commutes, airport transfers, and long-distance journeys."
    },
    {
        "name": "Etios Taxi",
        "description": "Travel comfortably in our well-maintained Toyota Etios taxis, ideal for city travel, family outings, and business trips. Experience punctual service, clean vehicles, and courteous drivers."
    },
    {
        "name": "Toyota Etios Taxi",
        "description": "Choose Toyota Etios taxis for a smooth and economical ride. Perfect for both short and long trips, these vehicles offer excellent fuel efficiency and spacious interiors."
    },
    {
        "name": "Toyota Etios Taxi Price",
        "description": "Check competitive and fair pricing for Toyota Etios taxis in Pune. Our affordable fares cater to daily commutes, airport transfers, and outstation travel with no hidden charges."
    },
    {
        "name": "Etios Car Taxi Price",
        "description": "Transparent Etios car taxi prices available for local and outstation travel. Get the best deals on comfortable rides with professional drivers and on-time service."
    },
    {
        "name": "Toyota Etios on Rent in Pune",
        "description": "Rent a Toyota Etios taxi in Pune for hourly, daily, or outstation use. Our rental service offers flexible packages tailored to your travel needs, ensuring convenience and comfort."
    },
    {
        "name": "Toyota Etios Car Rental Service in Pune",
        "description": "Reliable Toyota Etios car rental service in Pune for business trips, family outings, and sightseeing tours. Enjoy well-maintained vehicles and experienced drivers at affordable rates."
    },
    {
        "name": "Etios Cab Packages in Pune",
        "description": "Choose from a variety of Etios cab packages in Pune designed to suit your travel requirements including city tours, airport transfers, and outstation trips with all-inclusive pricing."
    },
    {
        "name": "Etios Outstation Cab Fare",
        "description": "Affordable and transparent Etios taxi fares for outstation travel from Pune. Experience comfortable journeys to nearby cities with reliable drivers and competitive pricing."
    },
    {
        "name": "Book Etios Taxi in Pune",
        "description": "Book your Etios taxi in Pune quickly through our online platform or phone booking service. Enjoy professional service, punctual pickups, and comfortable rides across the city."
    },
    {
        "name": "Etios Cab for Outstation Trip",
        "description": "Plan your outstation trips with our Etios cab service offering comfort, affordability, and safety. Perfect for trips to Mumbai, Nashik, Lonavala, and other nearby destinations."
    },
    {
        "name": "Affordable Etios Taxi in Pune",
        "description": "Get affordable Etios taxi options in Pune without compromising on service quality. Ideal for budget-conscious travelers seeking reliable and comfortable rides."
    },
    {
        "name": "Etios Dzire Alternative",
        "description": "Opt for Etios taxis as a cost-effective alternative to Dzire cabs in Pune, offering similar comfort and space at competitive rates for city and outstation travel."
    },
    {
        "name": "Etios Family Cab Pune",
        "description": "Perfect for family outings, our Etios family cabs in Pune provide spacious seating and a smooth ride, ensuring a safe and enjoyable travel experience for you and your loved ones."
    }
],
"tableData": [
    ["Etios Taxi Rate per km", "Etios Taxi Booking Online"],
    ["Etios Taxi", "Toyota Etios Taxi"],
    ["Toyota Etios Taxi Price", "Etios Car Taxi Price"],
    ["Toyota Etios on Rent in Pune", "Toyota Etios Car Rental Service in Pune"],
    ["Etios Cab Packages in Pune", "Etios Outstation Cab Fare"],
    ["Book Etios Taxi in Pune", "Etios Cab for Outstation Trip"],
    ["Affordable Etios Taxi in Pune", "Etios Dzire Alternative"],
    ["Etios Family Cab Pune", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Etios Cab Service for Outstation Trips from Pune",
        "WhyChoosedescription": "Prince Cabs offers Toyota Etios cabs for outstation travel from Pune, combining comfort and affordability. Whether you’re planning a weekend getaway, business trip, or family visit, our Etios cabs provide a smooth, fuel-efficient ride with ample space for passengers and luggage, making your long-distance journey hassle-free."
    },
    {
        "WhyChooseheading": "Comfortable Interiors and Ample Space",
        "WhyChoosedescription": "Our Etios vehicles feature comfortable seating with good legroom and a clean, well-maintained cabin. Designed to accommodate up to four passengers comfortably, these sedans are perfect for small groups or solo travelers who prioritize comfort without compromising on budget."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Outstation Routes",
        "WhyChoosedescription": "Our professional drivers have extensive knowledge of Pune’s surrounding highways and outstation routes. They ensure safe driving practices, timely pickups, and efficient navigation to your destination, prioritizing your safety and convenience throughout the journey."
    },
    {
        "WhyChooseheading": "Flexible Booking for One-Way, Round Trips & Multi-Day Rentals",
        "WhyChoosedescription": "Whether you require a one-way drop, same-day return, or extended outstation trip, Prince Cabs offers flexible rental packages for the Etios cab. You can book easily via phone, WhatsApp, or online portal, with transparent pricing and no hidden costs."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Options",
        "WhyChoosedescription": "Our pricing is competitive and clear, including all taxes, tolls, and driver allowances. We accept secure payments through UPI, credit/debit cards, net banking, and cash, providing a seamless and trustworthy booking experience."
    },
    {
        "WhyChooseheading": "Strict Hygiene & Safety Protocols",
        "WhyChoosedescription": "Each Etios cab undergoes thorough cleaning and sanitization before every trip to ensure passenger health and safety. Our vehicles are regularly maintained and equipped with essential safety features like seat belts and airbags for your peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Smooth Travel Experience",
        "WhyChoosedescription": "Our customer support team is available around the clock to assist you with Etios cab bookings, itinerary changes, and any travel-related queries, ensuring a hassle-free and enjoyable outstation journey from Pune."
    }
]






















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Etios cab service for outstation trips from Pune?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable Etios cabs for outstation travel from Pune to nearby cities and tourist destinations.',
    },
    {
        question: 'What are the seating and luggage capacities of the Etios cab?',
        answer: 'The Toyota Etios comfortably seats up to 4 passengers with ample space for luggage, making it ideal for small groups and solo travelers.',
    },
    {
        question: 'Can I book an Etios cab for one-way or round-trip outstation journeys?',
        answer: 'Absolutely! We provide both one-way and round-trip bookings for outstation travel to suit your itinerary and convenience.',
    },
    {
        question: 'Are Etios cabs sanitized and maintained for safety?',
        answer: 'Yes, all our Etios cabs are regularly sanitized and well-maintained to ensure your safety and comfort during the journey.',
    },
    {
        question: 'What is the approximate fare for Etios cab outstation trips from Pune?',
        answer: 'Fares vary depending on the destination, distance, and duration. Please contact Prince Cabs for a customized and competitive quote.',
    },
    {
        question: 'How do I book an Etios cab for outstation travel from Pune?',
        answer: 'You can easily book online via our website or call our support team with your travel details to confirm your booking.',
    },
    {
        question: 'Are professional drivers provided with the Etios cab service?',
        answer: 'Yes, our drivers are background-verified, experienced, and committed to providing safe and courteous service throughout your trip.',
    },
];

const testimonials = [
    {
        name: "Mr. Sandeep Kulkarni",
        position: "Solo Traveler",
        text: "I booked an Etios cab for my outstation trip from Pune and was very satisfied with the comfort and timely service provided by Prince Cabs.",
        image: "/img/testimonial/testimonial-thumb-etios-1.png",
    },
    {
        name: "Mrs. Priya Deshmukh",
        position: "Family Traveler",
        text: "Prince Cabs’ Etios cab was perfect for our weekend getaway. The driver was professional and the car well-maintained. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-etios-2.png",
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Etios Cab for Outstation in Pune",
  "description": "Book affordable Toyota Etios taxi for outstation trips from Pune. Reliable Etios cab service with competitive rates per km, online booking, and family packages.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Etios Taxi Booking",
    "Etios Outstation Cab",
    "Toyota Etios Rental",
    "Etios Family Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};



    return (
        <div>

<Helmet>
  <title>Etios Cab for Outstation in Pune | Affordable Toyota Etios Taxi</title>
  <meta
    name="description"
    content="Book affordable Toyota Etios taxi for outstation trips from Pune. Reliable Etios cab service with competitive rates per km, online booking, and family packages."
  />
  <meta
    name="keywords"
    content="Etios Taxi Rate per km, Etios Taxi Booking Online, Etios Taxi, Toyota Etios Taxi, Toyota Etios Taxi Price, Etios Car Taxi Price, Toyota Etios on Rent in Pune, Toyota Etios Car Rental Service in Pune, Etios Cab Packages in Pune, Etios Outstation Cab Fare, Book Etios Taxi in Pune, Etios Cab for Outstation Trip, Affordable Etios Taxi in Pune, Etios Dzire Alternative, Etios Family Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Etioscabforoutstationinpune ;